<div [@slideInOut]
     *ngIf="openedAction === 'addSection'">
  <db-section-templates
    (sectionTemplatesOpenedChange)="closeAddSection()"
    [page]="pageInteractionsService.openAddSection.value"
    [templates]="sectionTemplates">
  </db-section-templates>
</div>

<div [@slideInOut]
     *ngIf="openedAction === 'editSection'">
  <db-section-edit-tooltip
    (close)="closeEditSection()"
    [sectionType]="pageInteractionsService.openSectionEdit.value?.section?.section_type"
    [page]="pageInteractionsService.openSectionEdit.value">
  </db-section-edit-tooltip>
</div>

<div [@slideInOut]
     *ngIf="openedAction === 'addPage'">
  <db-add-page-tooltip (close)="closeAddPage()">
  </db-add-page-tooltip>
</div>
